import React, {useState} from 'react';

import type {ClassroomModelV1} from '@albert-io/models';
import {NewClassroomModal} from 'client/Classrooms/Teacher/NewClassroomModal/NewClassroomModal.react';
import {history} from 'client/history';

import {useTeacherClassroomActions} from '../../hooks/useTeacherClassrooms';
import {getCreatedClassRoute} from '../../Sidemenu/teacherNavScope';

interface NewClassroomModalControls {
  openNewClassroom: () => void;
  /** Render alongside the trigger — the modal element while open, otherwise null. */
  newClassroomModal: React.ReactNode;
}

export const useNewClassroomModal = (): NewClassroomModalControls => {
  const {fetchClassrooms} = useTeacherClassroomActions();
  const [isOpen, setIsOpen] = useState(false);

  return {
    openNewClassroom: () => setIsOpen(true),
    newClassroomModal: isOpen ? (
      <NewClassroomModal
        handleClose={() => setIsOpen(false)}
        onSubmit={(created: ClassroomModelV1) => {
          fetchClassrooms();
          history.pushState(null, getCreatedClassRoute(created.getId()));
        }}
      />
    ) : null
  };
};
